const React = require('react');

const Container = require('../common/Container.jsx');
const Content = require('../common/Content.jsx');
const Item = require('../common/Item.jsx');
const TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

function StringItem(props) {
    const itemData = props.itemData || {};
    const propName = props.propName || props.name;
    const hasValue = props.formatValue != false || !Utilities.isNullOrWhitespace(itemData[propName]);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, props.name)) {
            return null;
        }
    }
    return <Content.LabelValue {...props} renderPlaceholder={!hasValue} value={itemData[propName]} />;
}

const TypeConfigContent = {
    panel: {
        block: function (label, valueFontStyle, valueTextTransform) {
            const _label = label || {};
            return {
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType(),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, _label, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.value({}, valueFontStyle, valueTextTransform)
                ]
            };
        }
    }
};

function Artist(props) {
    const itemData = props.itemData || {};
    let value;
    if (itemData.Artist) {
        value = itemData.Artist.Name;
    }
    const hasValue = !Utilities.isNullOrWhitespace(value);
    if (!props.builder && !hasValue) {
        return null;
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={value} />;
}
const TypeConfigArtist = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Artist: ' }, {}, {}); },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

function ArtistBio(props) {
    const itemData = props.itemData || {};
    let artistBio, artistName;
    if (itemData.Artist) {
        artistBio = itemData.Artist.Bio;
        artistName = itemData.Artist.Name;
    }
    const config = props.config || {};
    if (!props.builder) {
        if (Utilities.isNullOrWhitespace(artistBio)) {
            return null;
        }
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, 'ArtistBio')) {
            return null
        }
    }
    let blockProps = {};
    let includes = {};
    if (config.Config) {
        if (config.Config.Block) {
            blockProps = config.Config.Block;
        }
        if (config.Config.Includes) {
            includes = config.Config.Includes;
        }
    }
    const data = props.data || {};
    let styleName;
    if (includes.ArtistName) {
        styleName = Utilities.Config.getStyle(data, blockProps, 'Name');
    }
    const styleBio = Utilities.Config.getStyle(data, blockProps, 'Bio');

    let borderStyle;
    if (!Utilities.isNullOrWhitespace(blockProps.borderTop)) {
        borderStyle = { borderTop: blockProps.borderTop };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderTopSpacing)) {
        borderStyle = borderStyle || {};
        borderStyle.paddingTop = blockProps.borderTopSpacing;
    }
    let borderTop;
    if (borderStyle) {
        borderTop = <tr><td style={borderStyle} /></tr>;
    }

    borderStyle = undefined;
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottom)) {
        borderStyle = { borderBottom: blockProps.borderBottom };
    }
    if (!Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing)) {
        borderStyle = borderStyle || {};
        borderStyle.paddingTop = blockProps.borderBottomSpacing;
    }
    let borderBottom;
    if (borderStyle) {
        borderBottom = <tr><td style={borderStyle} /></tr>;
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            onClick={props.onClick}
            onDragStart={props.onDragStart}>
            {borderTop}
            <tr>
                <td>
                    {
                        includes.ArtistName &&
                        !Utilities.isNullOrWhitespace(artistName) &&
                        <span style={styleName}>{artistName} </span>
                    }
                    <span dangerouslySetInnerHTML={{ __html: artistBio }} style={styleBio} />
                    {
                        props.builder &&
                        <React.Fragment>
                            {
                                (!includes.ArtistName || Utilities.isNullOrWhitespace(artistName)) &&
                                Utilities.isNullOrWhitespace(artistBio) &&
                                Utilities.Builder.emptyBlockPlaceholder()
                            }
                            {Utilities.Builder.dragOutline()}
                        </React.Fragment>
                    }
                </td>
            </tr>
            {borderBottom}
        </Container>
    );
}
const TypeConfigArtistBio = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    ...TypeConfig.options.border(),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Artist Name Properties', id: 'nameProps', type: 'header' },
                    ...TypeConfig.options.text({ name: 'Name' }, {}, {}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Artist Biography Properties', id: 'bioProps', type: 'header' },
                    ...TypeConfig.options.text({ name: 'Bio' }, {}, {})
                ]
            };
        },
        includes: function () {
            return {
                expanded: false,
                label: 'Include',
                options: [
                    { display: 'Artist Name', name: 'ArtistName', type: 'checkbox', value: true }
                ]
            };
        },
        style: Content.TypeConfig.value.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Artist Bio',
                        name: 'ArtistBio',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function CustomMeta(props) {
    return <Item.CustomMeta.Component component={Content.LabelValue} {...props} />;
}
const TypeConfigCustomMeta = {
    panel: {
        block: function () {
            return {
                expanded: false,
                label: 'Block Configuration',
                options: [
                    Content.TypeConfig.labelValue.options.displayType(),
                    { display: 'Label Properties', id: 'labelProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options.label({}, { value: 'Details: '}, {}),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    { display: 'Value Properties', id: 'valueProps', type: 'header' },
                    ...Content.TypeConfig.labelValue.options._columns('Value')
                ]
            };
        },
        includes: function () {
            return {
                draggable: true,
                expanded: true,
                label: 'Include / Order',
                options: [
                    {
                        display: 'Artist',
                        draggable: true,
                        fullWidth: true,
                        name: 'Artist',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        display: 'Title',
                        draggable: true,
                        fullWidth: true,
                        name: 'Title',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Edition') >= 0; },
                        display: 'Edition Info',
                        draggable: true,
                        fullWidth: true,
                        name: 'Edition',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Date') >= 0; },
                        display: 'Year',
                        draggable: true,
                        fullWidth: true,
                        name: 'Date',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Medium') >= 0; },
                        display: 'Medium',
                        draggable: true,
                        fullWidth: true,
                        name: 'Medium',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Signature') >= 0; },
                        display: 'Signature',
                        draggable: true,
                        fullWidth: true,
                        name: 'Signature',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Dimensions') >= 0; },
                        display: 'Dimensions',
                        draggable: true,
                        fullWidth: true,
                        name: 'Dimensions',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Number') >= 0; },
                        display: 'Inventory Number',
                        draggable: true,
                        fullWidth: true,
                        name: 'Number',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('SKU') >= 0; },
                        display: 'SKU',
                        draggable: true,
                        fullWidth: true,
                        name: 'SKU',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        configurableDuringExport: function (type, config) { return config.Includes._export && config.Includes._export.indexOf('Price') >= 0; },
                        display: 'Price',
                        draggable: true,
                        fullWidth: true,
                        name: 'Price',
                        type: 'checkbox',
                        value: true
                    },
                    {
                        name: '_sort',
                        value: ['Artist', 'Title', 'Edition', 'Date', 'Medium', 'Signature', 'Dimensions', 'Number', 'SKU', 'Price'],
                        visible: function () { return false; }
                    },
                    {
                        name: '_export',
                        value: ['Artist', 'Title', 'Edition', 'Date', 'Medium', 'Signature', 'Dimensions', 'Number', 'SKU', 'Price'],
                        visible: function () { return false; }
                    }
                ]
            };
        },
        meta: function () {
            return {
                expanded: false,
                label: 'Item Detail Configuration',
                options: [
                    { display: 'Artist Display Properties', id: 'artistProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Artist', value: '[Artist]' }, {}),
                    { display: 'Date Display Properties', id: 'dateProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Date', value: '[Date]' }, {}),
                    { display: 'Dimensions Display Properties', id: 'dimensionsProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Dimensions', value: '[Dimensions]' }),
                    { display: 'Edition Info Display Properties', id: 'editionProps', type: 'header' },
                    {
                        display: 'Limited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber], [EditionCount]',
                        name: 'formatEditionLimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]/[EditionCount]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    {
                        display: 'Unlimited Edition Display Format',
                        fullWidth: true,
                        helpText: () => 'Keywords: [EditionNumber]',
                        name: 'formatEditionUnlimited',
                        type: 'format',
                        value: 'Edition [EditionNumber]',
                        visible: function (config) {
                            return config.Includes && config.Includes.Edition;
                        }
                    },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Edition', type: 'edition' }),
                    { display: 'Inventory Number Display Properties', id: 'numberProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[Number]', name: 'Number', value: 'Inventory #: [Number]' }),
                    { display: 'Medium Display Properties', id: 'mediumProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Medium', value: '[Medium]' }, {}),
                    { display: 'Price Display Properties', id: 'priceProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Price', type: 'currency' }),
                    { display: 'Signature Display Properties', id: 'titleProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Signature', value: '[Signature]' }, {}),
                    { display: 'SKU Display Properties', id: 'skuProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ keywords: '[SKU]', name: 'SKU', value: 'SKU: [SKU]' }),
                    { display: 'Title Display Properties', id: 'titleProps', type: 'header' },
                    ...Item.CustomMeta.TypeConfig.options.meta({ name: 'Title', value: '[Title]' }, {})
                ]
            };
        },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

function Dimensions(props) {
    return <StringItem {...props} formatValue={false} name="Dimensions" />;
}
const TypeConfigDimensions = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Size: ' }, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: Item.Dimensions.TypeConfig.panel.visibility
    }
};

function Edition(props) {
    const itemData = props.itemData || {};
    let formatProps = {};
    if (props.config && props.config.Config && props.config.Config.Format) {
        formatProps = props.config.Config.Format;
    }
    const value = Utilities.Inventory.getEditionNumberWithFormat(itemData, formatProps.formatLimited, formatProps.formatUnlimited);
    const hasValue = !Utilities.isNullOrWhitespace(value);
    if (!props.builder) {
        if (!hasValue) {
            return null;
        }
        const config = props.config || {};
        if (!props.forceVisibility && !Utilities.Config.getVisibility(config, props.name)) {
            return null;
        }
    }
    return <Content.LabelValue {...props} formatValue={false} renderPlaceholder={!hasValue} value={value} />;
}
const TypeConfigEdition = {
    panel: {
        block: function () { return TypeConfigContent.panel.block(undefined, {}); },
        format: Item.Edition.TypeConfig.panel.format,
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: Item.Edition.TypeConfig.panel.visibility
    }
};

function InsuranceValue(props) {
    return <StringItem {...props} name="InsuranceValue" />;
}
const TypeConfigInsuranceValue = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Insurance: ' }, {}); },
        format: function () { return TypeConfig.panel.currency(); },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

function Medium(props) {
    return <StringItem {...props} formatValue={false} name="Medium" />;
}
const TypeConfigMedium = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Medium: ' }, {}, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Medium',
                        name: 'Medium',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Notes(props) {
    let style = {};
    if (props.style) {
        style = { ...style };
    }
    style.whiteSpace = 'pre';
    return <Item.StringMeta.Component {...props} name="Notes" style={style} />;
}
const TypeConfigNotes = {
    panel: {
        block: function () { return Item.StringMeta.TypeConfig.panel.block({}); },
        style: Item.StringMeta.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Notes',
                        name: 'Notes',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Number(props) {
    return <StringItem {...props} formatValue={false} name="Number" />;
}
const TypeConfigNumber = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Inventory #: ' }, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Inventory Number',
                        name: 'Number',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Price(props) {
    return <StringItem {...props} name="Price" />;
}
const TypeConfigPrice = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Price: ' }, {}); },
        format: Item.Price.TypeConfig.panel.format,
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () { return Item.Price.TypeConfig.panel.visibility(); }
    }
};

function Signature(props) {
    return <StringItem {...props} formatValue={false} name="Signature" />;
}
const TypeConfigSignature = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Signature: ' }, {}, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Signature Placement',
                        name: 'Signature',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function SKU(props) {
    return <StringItem {...props} formatValue={false} name="SKU" />;
}
const TypeConfigSKU = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'SKU: ' }, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'SKU',
                        name: 'SKU',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

function Title(props) {
    let includes = {}
    if (props.config && props.config.Config && props.config.Config.Includes) {
        includes = props.config.Config.Includes;
    }
    const itemData = props.itemData || {};
    let subtitle = Utilities.Inventory.getSubtitle(itemData, includes.Edition, false);
    if (subtitle && subtitle.length > 0) {
        subtitle = <span style={{ fontStyle: 'initial' }}>{subtitle}</span>;
    }
    const value = <span style={{ fontStyle: 'italic' }}>{itemData.Title}{subtitle}</span>;
    return <Content.LabelValue {...props} formatValue={false} value={value} />;
}
const TypeConfigTitle = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Title: ' }, undefined, {}); },
        includes: function () { return Item.Title.TypeConfig.panel.includes(); },
        style: Content.TypeConfig.labelValue.panel.style
    }
};

function Year(props) {
    return <StringItem {...props} formatValue={false} name="Year" propName="Date" />;
}
const TypeConfigYear = {
    panel: {
        block: function () { return TypeConfigContent.panel.block({ value: 'Year: ' }, {}); },
        style: Content.TypeConfig.labelValue.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Date',
                        name: 'Year',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

module.exports = {
    ...Item,
    Artist: {
        Component: Artist,
        TypeConfig: TypeConfigArtist
    },
    ArtistBio: {
        Component: ArtistBio,
        TypeConfig: TypeConfigArtistBio
    },
    CustomMeta: {
        Component: CustomMeta,
        TypeConfig: TypeConfigCustomMeta
    },
    Dimensions: {
        Component: Dimensions,
        TypeConfig: TypeConfigDimensions
    },
    Edition: {
        Component: Edition,
        TypeConfig: TypeConfigEdition
    },
    InsuranceValue: {
        Component: InsuranceValue,
        TypeConfig: TypeConfigInsuranceValue
    },
    Medium: {
        Component: Medium,
        TypeConfig: TypeConfigMedium
    },
    Notes: {
        Component: Notes,
        TypeConfig: TypeConfigNotes
    },
    Number: {
        Component: Number,
        TypeConfig: TypeConfigNumber
    },
    Price: {
        Component: Price,
        TypeConfig: TypeConfigPrice
    },
    Signature: {
        Component: Signature,
        TypeConfig: TypeConfigSignature
    },
    SKU: {
        Component: SKU,
        TypeConfig: TypeConfigSKU
    },
    Title: {
        Component: Title,
        TypeConfig: TypeConfigTitle
    },
    Year: {
        Component: Year,
        TypeConfig: TypeConfigYear
    }
};